import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { WizardStepStore } from './wizard-step-store';
import { WizardStep } from './wizard-step.model';

@Injectable({ providedIn: 'root' })
export class WizardStepService {
    constructor(private wizardStepStore: WizardStepStore) {}

    /*---------------------*/
    /** OPERACIONES ENTITY */
    /*---------------------*/

    add(wizardStep: WizardStep) {
        this.wizardStepStore.add(wizardStep);
    }

    update(id, wizardStep: Partial<WizardStep>) {
        this.wizardStepStore.update(id, wizardStep);
    }

    remove(id: ID) {
        this.wizardStepStore.remove(id);
    }

    setWizardSteps(steps: WizardStep[]) {
        this.wizardStepStore.set(steps);
    }

    /*------------*/
    /** SERVICIOS */
    /*------------*/

    setActive(stepId: string) {
        this.wizardStepStore.setActive(stepId);
    }

    resetStore() {
        this.wizardStepStore.reset();
    }
}
